<template>
  <tr-dialog
    ref="modal"
    name="receivers-bulk-delete-confirmation-dialog"
    title="Excluir Recebedores"
  >
    <div>
      <tr-typography
        classes="vertical-offset2 inline-block"
        variant="h5"
      >
        Você deseja excluir os recebedores selecionados?
      </tr-typography>
    </div>
    <template #buttons>
      <tr-button
        classes="pull-right"
        :on-button-click="onConfirm"
        label="Excluir"
        variant="raised"
        color="danger"
      />
    </template>
  </tr-dialog>
</template>

<script>
export default {
  name: 'receivers-bulk-delete-confirmation-dialog',
  props: {
    onConfirm: {
      required: true,
      type: Function
    }
  },
  methods: {
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    }
  }
};
</script>
